import { periodNoun } from "@volca/ui/trades";
import { dayjs } from "@/core/utils/date";
import { withTrueMinus } from "@/profitability/currency";
import type { TrendPeriod } from "./types";

export { points } from "@volca/ui/trades";

export const periodOf = (
  periods: Pick<TrendPeriod, "start_date" | "end_date">[],
) => {
  const lengths = periods
    .map((period) => dayjs(period.end_date).diff(period.start_date, "day") + 1)
    .sort((a, b) => a - b);
  return periodNoun(lengths[Math.floor(lengths.length / 2)] ?? 7);
};

export const periodLabel = (date: string, noun: string) =>
  dayjs(date).format(noun === "month" ? "MMM" : "MMM D");

export const pct = (value: number | null | undefined, digits = 1) =>
  value === null || value === undefined
    ? "—"
    : `${withTrueMinus(value * 100, { maximumFractionDigits: digits, minimumFractionDigits: digits })}%`;

export { formatMoney as money } from "@/profitability/currency";

/**
 * A dataset's margin across all its records: what they made over what they
 * took in. Only records with both figures count; a missing one is left out,
 * never taken as zero (FIN-004).
 */
export const overallMargin = (
  rows: { total: number | null; result: number | null }[],
) => {
  const present = rows.filter(
    (row) => row.total !== null && row.result !== null,
  );
  const total = present.reduce((sum, row) => sum + (row.total ?? 0), 0);
  return total
    ? present.reduce((sum, row) => sum + (row.result ?? 0), 0) / total
    : null;
};
